import uniq from 'lodash.uniq';
import {
  DatatypeOperator,
  ObjectOperator,
  TopExpression,
  Variable,
} from 'vet-bones/utils/queryBuilder';

import { buildThenFilter } from 'src/utils/stringify/rules/buildThenFilter';

export const buildThenClause = ({
  abbreviate,
  getVariable,
  instancesByIds,
  topExpression,
}: {
  abbreviate: (iri: string) => string;
  getVariable: (variable: string, id?: string) => string;
  instancesByIds: Array<Record<string, string>>;
  topExpression: TopExpression;
  isVirtual?: boolean;
}): string => {
  const triples: string[] = [];
  instancesByIds.forEach((instancesById) => {
    const getInstanceIri = (subject: Variable): string =>
      instancesById[subject.id] || '';

    topExpression.expressions.forEach(({ expressions }) =>
      expressions.forEach(({ filters }) =>
        filters.forEach((filter) => {
          const { subject, operator, value } = filter;
          const thenFilter = buildThenFilter({
            abbreviate,
            getInstanceIri,
            getVariable,
            // no instance operator type for then filters
            operator: operator as DatatypeOperator | ObjectOperator,
            subject,
            value: value as Variable | string,
          });
          if (thenFilter) {
            triples.push(thenFilter);
          }
        })
      )
    );
  });

  return `THEN {
  ${uniq(triples).join('\n  ')}
}`;
};
